// extracted by mini-css-extract-plugin
export default {"container":"XJ-z","dimension":"YJ-z","dimensionLabels":"ZJ-z"};